import Vue from 'vue'
import * as types from '../mutation-types/pages'
const EventBus = window.VueEventBus

// set this true to namespace all getters, mutations, actions etc.
const namespaced =  true
export const namespace = 'pages'

// state
const state = {
  postLoginPage: 'page-profile',
  postLoginSection: null,
  isPreCheckoutRegistration: false,
  checkoutState: 'cart',
  showingResetPassword: false,
  userVerificationPrompt: false,
  showGlobalTimer: true,
  alertOnTimeoutShown: false,
  timeoutRemovedTypes: {}
}

// mutations
const mutations = {
  [types.SET_POST_LOGIN_PAGE](state, page) {
    state.postLoginPage = page
  },
  [types.SET_POST_LOGIN_SECTION](state, page) {
    state.postLoginSection = page
  },
  [types.SET_PRE_CHECKOUT_REGISTRATION](state, yn) {
    state.isPreCheckoutRegistration = yn
  },

  [types.SET_CHECKOUT_STATE](state, stateType) {
    state.checkoutState = stateType
  },
  [types.SHOW_RESET_PASSWORD](state, show) {
    state.showingResetPassword = show === undefined ? true : show
  },
  [types.SHOW_USER_VERIFICATION_PROMPT](state, show) {
    state.userVerificationPrompt = show === undefined ? true : show
  },
  [types.HIDE_GLOBAL_TIMER](state, hide) {
    state.showGlobalTimer = hide === false
  },
  [types.SHOW_ITEM_REMOVED_ON_TIMEOUT_ALERT](state, show) {
    state.alertOnTimeoutShown = show !== false
  },
  [types.SET_ITEM_TYPE_REMOVED_ON_TIMEOUT](state, itemTypes) {
    if (_.isString(itemTypes)) {
      itemTypes = [itemTypes]
    }
    _.forOwn(itemTypes, itemType => {
      Vue.set(state.timeoutRemovedTypes, itemType, true)
    })
  }
}

const actions = {
  setPostLoginPage ({ commit }, payload) {
    commit(types.SET_POST_LOGIN_PAGE, payload)
  },
  setPostLoginSection ({ commit }, payload) {
    commit(types.SET_POST_LOGIN_SECTION, payload)
  },
  setIsPreCheckoutRegistration ({ commit }, yn) {
    commit(types.SET_PRE_CHECKOUT_REGISTRATION, yn)
  },
  setCheckoutState({commit, state}, stateType) {
    commit(types.SET_CHECKOUT_STATE, stateType)
  },
  showResetPassword({commit, state}, show) {
    commit(types.SHOW_RESET_PASSWORD, show)
  },
  showUserVerificationPrompt({commit, state}, show) {
    commit(types.SHOW_USER_VERIFICATION_PROMPT, show)
  },
  hideGlobalTimer({commit, state}, hide) {
    commit(types.HIDE_GLOBAL_TIMER, hide)
  },
  showTimeoutAlert({commit, state}, show) {
    commit(types.SHOW_ITEM_REMOVED_ON_TIMEOUT_ALERT, show)
  },
  setTimeoutRemovedTypes({commit, state}, itemTypes) {
    commit(types.SET_ITEM_TYPE_REMOVED_ON_TIMEOUT, itemTypes)
  }
}

// getters
const getters = {
  loginRedirect: state => state.postLoginPage,
  loginRedirectSection: state => state.postLoginSection,
  userVerificationPrompt: state => state.userVerificationPrompt,
  isPreCheckoutRegistration: state => state.isPreCheckoutRegistration,
  checkoutState: state => state.checkoutState,
  resettingPassword: state => state.showingResetPassword,
  showingGlobalTimer: state => state.showGlobalTimer,
  isAlertOnTimeoutShown: state => state.alertOnTimeoutShown,
  timeoutRemovedTypes: state => _.keys(state.timeoutRemovedTypes|| {})
}

const pages =  { namespaced, namespace, state, mutations, actions, getters }
export default pages
